import moment from "moment";
import * as logger from "./logger";
import * as urls from "./urls";
import i18n from "../i18n";

const isElectronApp = (check_dev) => {
  let app_string;
  if (check_dev) {
    app_string = "ActiveCollabDev";
  } else {
    app_string = "ActiveCollab";
  }

  return navigator.userAgent.indexOf(app_string) > -1 && navigator.userAgent.indexOf("Electron") > -1;
};

const Angie = {
  ...urls,
  logger,
  frontend_application_version: null,
  page_reload_needed: false,
  app_reloading: false,
  logged_user: {
    class: "",
  },
  functions: {
    phrase: (phrase, replacements) => {
      if (typeof replacements !== `object`) return phrase;

      let replacementKeys = Object.keys(replacements);

      if (!replacementKeys.length) return phrase;

      return replacementKeys.reduce((nextPhrase, key) => {
        return nextPhrase.replace(new RegExp(`:` + key, `g`), replacements[key]);
      }, phrase);
    },
    phpToMomentTimeFormat: (value = ``) => {
      return value.replace(`%M`, `mm`).replace(`%H`, `HH`).replace(`%I`, `hh`).replace(`%p`, `A`);
    },
    phpToMomentDateFormat: (value = ``) => {
      return value
        .replace(`%Y`, `YYYY`)
        .replace(`%y`, `YY`)
        .replace(`%b`, `MMM`)
        .replace(`%e`, `D`)
        .replace(`%a`, `ddd`)
        .replace(`%m`, `MM`)
        .replace(`%d`, `DD`);
    },
    isTouchDevice: () => {
      return window.matchMedia("only screen and (max-width: 480px)").matches;
    },
    isMediumDevice: () => {
      return window.matchMedia("only screen and (max-width: 992px)").matches;
    },
    format_file_size: (value) => {
      let data = {
        TB: 1099511627776,
        GB: 1073741824,
        MB: 1048576,
        kB: 1024,
      };

      let bytes, in_unit;
      for (let unit in data) {
        bytes = data[unit];
        in_unit = value / bytes;
        if (in_unit > 0.9) {
          return `${in_unit.toFixed(2)}${unit}`;
        } // if
      }

      return `${parseInt(value)}B`;
    },
    /**
     * @deprecated
     */
    decimalNumberToHours: (decimal) => {
      // we round it on two decimals first, to eliminate quirks, eg, 5.99999999 will return 5:59 instead of 6:00
      decimal = parseFloat(decimal).toFixed(2);
      decimal = decimal + "";
      var hours;
      var minutes;
      var minutes_decimal;

      if (decimal.indexOf(".") < 0) {
        hours = parseInt(decimal);
        minutes_decimal = 0;
      } else {
        hours = parseInt(decimal.substr(0, decimal.indexOf(".")));
        minutes_decimal = decimal.substr(decimal.indexOf(".") + 1);
        minutes_decimal = minutes_decimal.substr(0, 2);
        if (minutes_decimal.length === 1) {
          minutes_decimal += "0";
        } // if
        minutes_decimal = parseInt(minutes_decimal);
      } // if

      minutes = Math.round((minutes_decimal / 100) * 60);

      return {
        hours: hours,
        minutes: minutes,
      };
    },
    hoursFormatted: (hours_object, long, roundHours) => {
      var string = "%h:%m";
      var hours = hours_object.hours || 0;
      var minutes = hours_object.minutes || 0;

      var additionalHours = 0;

      // check if more than on hour in minutes was specified
      if (minutes / 60 >= 1) {
        additionalHours = Math.floor(minutes / 60);
        minutes = minutes - additionalHours * 60;
        hours += additionalHours;
      }

      // pad number of minutes with zero
      if (minutes < 10) {
        minutes = "0" + minutes;
      }

      if (long) {
        string = `%h ${i18n.t("hours")}, %m ${i18n.t("minutes")}`;
        if (hours === 1) {
          string = string.replace(i18n.t("hours"), i18n.t("hour"));
        }

        if (parseInt(minutes) === 1) {
          string = string.replace(i18n.t("minutes"), i18n.t("minute"));
        }
      }

      if (!long && roundHours && minutes === "00") {
        return hours;
      }

      return string.replace("%h", hours).replace("%m", minutes);
    },
    hoursToDecimal: (hours, minutes) => {
      if (!minutes) {
        return hours;
      } // if

      if (minutes >= 60) {
        hours += Math.floor(minutes / 60);
        minutes = minutes % 60;
      }

      var float_time = hours + minutes / 60;

      return parseFloat(float_time);
    },
    decimalToMinutes: function (decimal_time) {
      var time = this.decimalNumberToHours(decimal_time);
      return parseInt(time.hours * 60 + time.minutes);
    },
    timeStringToFloat: (time) => {
      if (typeof time === "string" && time.indexOf(",") > -1) {
        time = time.replace(",", ".");
      }

      let value = time;

      if (/:/.test(time)) {
        let [hours, minutes] = time.split(/[.:]/);

        hours = parseInt(hours, 10);

        if (isNaN(hours)) {
          hours = 0;
        }

        if (minutes.length === 1) {
          minutes += "0";
        }

        minutes = parseInt(minutes, 10);

        if (isNaN(minutes)) {
          minutes = 0;
        }

        value = (hours + minutes / 60).toFixed(2);
      }

      value = parseFloat(value);

      return isNaN(value) ? 0 : value;
    },
    slug: (text) => {
      // trim text
      text = text.trim();
      // first letter lowercase
      text = text.charAt(0).toLowerCase() + text.slice(1);
      // from camel case to dash
      text = text.replace(/([A-Z])/g, function ($1) {
        return "-" + $1.toLowerCase();
      });
      // remove non alpha-num characters
      text = text.replace(new RegExp("[^a-zA-Z0-9 -]", "g"), "").toLowerCase();
      // remove spaces
      text = text.replace(new RegExp(" ", "g"), "-");
      // replace repeating - with single -
      while (text.indexOf("--") > -1) {
        text = text.replace("--", "-");
      } // while
      // return the result
      return text;
    },
    random_hash: () => {
      return Math.random().toString(36).substr(2);
    },
    ago: function (date, timeFormat, dateFormat) {
      var timestamp;
      if (!date) {
        return "N/A";
      } else if (date instanceof Date) {
        timestamp = Math.round(date.getTime() / 1000);
      } else if (date instanceof Object) {
        return "N/A";
      } else {
        timestamp = parseInt(date);
        if ((timestamp + "").length > 10) {
          timestamp = Math.round(timestamp / 1000);
        }
      }

      var now = Math.round(Date.now() / 1000);
      var diff = now - timestamp;
      diff = Math.abs(diff);
      var moment_instance = moment.unix(timestamp);

      var currentDayStart = moment().startOf("day");
      var yesterdayStart = currentDayStart.add(-1, "days");
      var commentDateStart = moment(moment_instance).startOf("day");

      if (diff < 120) {
        return i18n.t("Just now");
      } else if (diff < 3600) {
        return i18n.t("{{number}} minutes ago", {
          number: Math.floor(diff / 60),
        });
      } else if (diff < 86400 && moment_instance.isSame(moment(), "day")) {
        return i18n.t("Today {{time}}", {
          time: moment_instance.format(timeFormat === "hh:mm A" ? "h:mm A" : "HH:mm"),
        });
      } else if (moment(yesterdayStart.toDate()).isSame(moment(commentDateStart.toDate()))) {
        return i18n.t("Yesterday {{time}}", {
          time: moment_instance.format(timeFormat === "hh:mm A" ? "h:mm A" : "HH:mm"),
        });
      } else if (moment_instance.isSame(moment(), "year")) {
        return (
          moment_instance.format(dateFormat === "MMM D. YYYY" ? "MMM D." : "D. MMM") +
          " " +
          moment_instance.format(timeFormat === "hh:mm A" ? "h:mm A" : "HH:mm")
        );
      }

      return (
        moment_instance.format(dateFormat ? dateFormat : "MMM D. YYYY") +
        " " +
        moment_instance.format(timeFormat === "hh:mm A" ? "h:mm A" : "HH:mm")
      );
    },
    escape_html: (unsafe) => {
      return `${unsafe}`
        .replace(/&/g, `&amp;`)
        .replace(/</g, `&lt;`)
        .replace(/>/g, `&gt;`)
        .replace(/"/g, `&quot;`)
        .replace(/'/g, `&#039;`);
    },
    get_contrast_class: (hexcolor) => {
      if (!hexcolor) return;
      hexcolor = hexcolor.replace("#", "");

      const r = parseInt(hexcolor.substr(0, 2), 16);
      const g = parseInt(hexcolor.substr(2, 2), 16);
      const b = parseInt(hexcolor.substr(4, 2), 16);
      const yiq = (r * 299 + g * 587 + b * 114) / 1000;

      return "contrast_" + (yiq > 140 ? "dark" : "light");
    },
    excerpt: (string, limit) => {
      string = string + "";

      if (!limit || string.length <= limit) {
        return string;
      }

      return string.substr(0, limit) + "…";
    },
    determinePrecision: (rawValue) => {
      var whole = "whole-hour";
      var quarter = "quarter-hour";
      var minute = "minute";
      var second = "second";

      if (/:/.test(rawValue)) {
        var minutes = rawValue.split(":")[1];
        if (minutes && parseInt(minutes) === 0) return whole;
        if (minutes && parseInt(minutes) % 15 === 0) return quarter;
        return minute;
      }

      if (/[,.]/.test(rawValue)) {
        var value = parseFloat(rawValue.replace(",", "."));
        if (value % 1 === 0) return whole;
        if (value % 0.25 === 0) return quarter;
        if ((value * 60) % 1 === 0) return minute;
        return second;
      }

      return whole;
    },
    sendElectronAppMessage: (name, message) => {
      if (!isElectronApp()) {
        return false;
      }

      $(document).trigger("electron-message", {
        name,
        value: message,
      });
    },
    get_domain: (url) => {
      let domain;
      //find & remove protocol (http, ftp, etc.) and get domain
      if (url.indexOf("://") > -1) {
        domain = url.split("/")[2];
      } else {
        domain = url.split("/")[0];
      }

      //find & remove port number
      domain = domain.split(":")[0];

      return domain;
    },
    removeUnreadIndicator: () => {
      Angie.user_session_data.new_features_count = 0;
    },
  },
  file_access_token: {
    thumb_token: "",
    preview_token: "",
    download_token: "",
    ttl: 0,
  },
  user_session_data: {
    new_features_count: 0,
  },
};
export default Angie;
